import { list } from "../api/question";

export const QuestionTypes = {
  GET_ALL_START: "question/GET_ALL_START",
  GET_ALL_SUCCESS: "question/GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "question/GET_ALL_FAILURE"
};

export const getAllStart = payload => ({
  type: QuestionTypes.GET_ALL_START,
  payload
});

export const getAllSuccess = payload => ({
  type: QuestionTypes.GET_ALL_SUCCESS,
  payload
});

export const getAllFailure = payload => ({
  type: QuestionTypes.GET_ALL_FAILURE,
  payload
});

export const getAllQuestions = payload => async dispatch => {
  dispatch(getAllStart());

  const response = await list(payload);

  if (response.ok) {
    const body = await response.json();
    dispatch(getAllSuccess(body.payload));
  } else {
    dispatch(getAllFailure());
  }
};



// WEBPACK FOOTER //
// ./src/actions/question.js